import React from "react";
import { Clock, Heart, ClipboardList } from "lucide-react";

const REASONS = [
  {
    icon: Clock,
    title: "Time saved, every single week",
    desc: "Stop juggling Excel, WhatsApp and sticky notes. Build plans, send check-ins, and log progress in one place — get 8–10 hours of your week back.",
    highlight: "8–10 hrs / week back",
  },
  {
    icon: Heart,
    title: "Client retention that pays you",
    desc: "Automated reminders, visible progress, and a branded client portal keep your clients engaged — so they renew instead of quietly drop off.",
    highlight: "Clients stay longer, pay longer",
  },
  {
    icon: ClipboardList,
    title: "Easy diet & workout planning",
    desc: "Drag-and-drop workout builder, macro-aware diet planner with Indian foods, and reusable templates. Build a personal plan in minutes, not hours.",
    highlight: "Plans ready in minutes",
  },
];

export default function WhyCoaches() {
  return (
    <section className="py-20 md:py-28" data-testid="why-coaches-section">
      <div className="section-container">
        <div className="text-center max-w-2xl mx-auto mb-14 reveal">
          <div className="chip mb-4">Why switch</div>
          <h2 className="font-display text-4xl md:text-5xl leading-tight">
            Why coaches switch to <span className="gradient-text">FitTrackCoach</span>
          </h2>
          <p className="mt-4 text-white/60">
            Built for coaches who want to <span className="text-white font-semibold">scale, not struggle</span>. Here's what changes from week one.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {REASONS.map((r, i) => {
            const Icon = r.icon;
            return (
              <div
                key={i}
                className="card-surface rounded-2xl p-6 md:p-7 reveal flex flex-col"
                data-testid={`why-card-${i}`}
              >
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-5"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(34,211,238,0.2), rgba(59,130,246,0.15))",
                    border: "1px solid rgba(34,211,238,0.3)",
                  }}
                >
                  <Icon size={22} className="text-cyan-300" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-white mb-2">{r.title}</h3>
                <p className="text-sm text-white/60 leading-relaxed flex-1">{r.desc}</p>
                <div
                  className="mt-5 inline-flex items-center self-start gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full"
                  style={{
                    background: "rgba(34,211,238,0.08)",
                    color: "#22D3EE",
                    border: "1px solid rgba(34,211,238,0.2)",
                  }}
                >
                  {r.highlight}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
